export default __webpack_public_path__ + "static/media/kitchen_background.a94620da.svg";